import xhr from '../tools/xhr.js';
import auth from '../tools/storage.js';
import tools from '../tools/tools.js';
import pointsMarkup from '../markup2/universalListOfDataBody.js';
import toolsMarkup from '../markup/tools.js';

const loaderSpinnerId = 'loader-enterprises';
const loaderSpinnerMessage = 'Загрузка';
const loaderSpinnerMarkup = toolsMarkup.getLoadSpinner(loaderSpinnerId, loaderSpinnerMessage);
  

const menuGlobalNominations = document.querySelector('#MenuGlobalNominations');
const menuGlobalTechs = document.querySelector('#MenuGlobalTechs');
const menuGlobalPosts = document.querySelector('#MenuGlobalPosts');
// const menuGlobalSectionsForJury = document.querySelector('#MenuGlobalSectionsForJury');
// 
// const tabMailingAlertToBuyBtClose = tabMailingAlertToBuy.querySelector('button[name=closePurchase]');
const universalView = document.querySelector('#UniveralListOfGlobalData');
const universalViewLabel = universalView.querySelector('h2[name=label]');
const universalViewAddBt = universalView.querySelector('button[name=add]');
// const universalViewAddValue = universalView.querySelector('button[name=closePurchase]');
const universalViewRefreshBt = universalView.querySelector('button[name=refresh]');
const universalViewSearchFiled = universalView.querySelector('input[name=search]');
const universalViewBody = universalView.querySelector('div[name=body]');

let msgBeforeAdd;
let urlPath;
let searchedData;
let servAnswerData;
let servAnswerFestAvailableData;
let footerTip;
// let view

let modeAvailiable = false;

const initGlobalNominations = () => {

  servAnswerFestAvailableData = [];
  modeAvailiable = true;
  msgBeforeAdd = 'Вы точно хотите, добавить новую номинацию?';
  footerTip = '';
  urlPath = 'nominations';
  loadAvailable(urlPath);
  universalViewLabel.innerHTML = 'Номинации:';
  getServData();
};


const initGlobalTechs = () => {
  servAnswerFestAvailableData = [];
  modeAvailiable = true;
  msgBeforeAdd = 'Вы точно хотите, добавить новую технику?';
  footerTip = `<div class="row m-0 p-3">
                <div class="tipExclamationMark"><h1>!</h1></div>
                <b class="w-90"> Укажите, какие техники будут видны и доступны вашим заявителям при создании новой заявки. 
                <br>Если заявитель создал фильм, до начала приема заявок на ваш фестиваль, то ему будут видны все техники.</b>
              </div>`;
  urlPath = 'techs';
  loadAvailable(urlPath);
  universalViewLabel.innerHTML = 'Техники:';
  getServData();
};


const initGlobalPosts = () => {

  servAnswerFestAvailableData = [];
  modeAvailiable = true;
  msgBeforeAdd = 'Вы точно хотите, добавить новую  должность?';
  footerTip = `<div class="row m-0 p-3">
                <div class="tipExclamationMark"><h1>!</h1></div>
                <b class="w-90"> Укажите, какие должности будут видны и доступны вашим заявителям при заполнении блока "над фильмом работали".
                <br>Если заявитель создал фильм, до начала приема заявок на ваш фестиваль, то ему будут видны все должности.<br><br>Если у вашего фестиваля, есть обязательные должности, то сообщите об этом главному администратору.</b>
              </div>`;
  urlPath = 'posts';
  loadAvailable(urlPath);
  universalViewLabel.innerHTML = 'Должности:';
  getServData();
};


// const initGlobalSectionsForJury = () => {
//   msgBeforeAdd = 'Вы точно хотите, создать новую  секцию для жюри?';
//   urlPath = 'jurySections';
//   universalViewLabel.innerHTML = 'Секции жюри:';
//   getServData();

// };

function loadAvailable(parametr){
  xhr.request = {
      metod: 'GET',
      url: `festival/${auth.currentFestival}/available/${parametr}`,
      data: '',
      callbackSuccess: onSuccessLoadAvailable
    };

}
// УНИВЕРСАЛЬНЫЙ КАРКАС 
const onSuccessLoadAvailable = (servAnswer) => {
  if (servAnswer.status === 200) 
    servAnswerFestAvailableData = servAnswer.data;
  else
    servAnswerFestAvailableData = [];
    reloadList();
};




// УНИВЕРСАЛЬНЫЙ КАРКАС 
const onSuccessPointsLoad = (servAnswer) => {
  if (servAnswer.status === 200) {
    servAnswerData = servAnswer.data;
    reloadList();
  } else 
    pointsMarkup.drawMarkupInContainer(`<p>${servAnswer.message}</p>`);
};




universalViewSearchFiled.addEventListener('keyup', function () {

  if(universalViewSearchFiled.value.length > 1)
    universalViewAddBt.disabled = false;
  else 
    universalViewAddBt.disabled = true;

  reloadList();
});


function reloadList() {
    if(universalViewSearchFiled.value.length == 0)
      pointsMarkup.drawDataInContainer(servAnswerData, modeAvailiable , servAnswerFestAvailableData);
      // pointsMarkup.drawDataInContainer(allFilms);
    else{
      searchedData = [];

      servAnswerData.forEach((element) => {
        if(tools.kmpSearch(universalViewSearchFiled.value,element.name ) != -1)
          searchedData.push(element);
      });
      
    
        pointsMarkup.cleanContainer();
     if(searchedData.length == 0)
        pointsMarkup.drawMarkupInContainer(`<p style="color:black;">Поиск не дал результатов</p>`)
      else
        pointsMarkup.drawDataInContainer(searchedData , modeAvailiable , servAnswerFestAvailableData);
    }

    document.querySelector('#UniveralListOfGlobalData').querySelector('div[name=body]').innerHTML += footerTip;
}

universalViewBody.addEventListener('click', function (evt) {
  evt.preventDefault();
  if (evt.target.attributes.action && evt.target.attributes.elementID) {
    let action = evt.target.attributes.action.nodeValue;
    let elementID = evt.target.attributes.elementID.nodeValue;

    if (action == 'remove') {
      if(confirm(`Вы уверены, что хотите удалить елемент?\n"${evt.target.attributes.elementName.nodeValue}"\n\nДанный элемент будет удален, если на него не будут ссылаться другие объекты.`)){
        xhr.request = {
          metod: 'DELETE',
          url: urlPath,
          data: `id=${evt.target.attributes.elementID.nodeValue}`,
          callbackSuccess: onSuccessCardLoad
        };
      };
    } else if (action == 'link' || action == 'unlink') {
        xhr.request = {
          metod: 'PUT',
          url: `festival/${auth.currentFestival}/available/${urlPath}/${action}/${elementID}`,
          data: `id=${evt.target.attributes.elementID.nodeValue}`,
          callbackSuccess: onSuccessLoadAvailable
        };

    }
  }
});

universalViewRefreshBt.addEventListener('click', function () {
  getServData();

  loadAvailable(urlPath);
});

universalViewAddBt.addEventListener('click', function () {
  if(confirm(msgBeforeAdd))
  xhr.request = {
    metod: 'POST',
    url: urlPath,
    data: `name=${universalViewSearchFiled.value}`,
    callbackSuccess: onSuccessCardLoad
  };

});


const onSuccessCardLoad = (servAnswer) => {

  if (servAnswer.status === 200) {
    // universalViewSearchFiled.value = '';
    universalViewAddBt.disabled = true;
    getServData();
  }
};
const getServData = () => {

  pointsMarkup.cleanContainer();
  pointsMarkup.drawMarkupInContainer(loaderSpinnerMarkup);

  xhr.request = {
    metod: 'GET',
    url: urlPath,
    data: '',
    callbackSuccess: onSuccessPointsLoad
  };
};



export default {

  start() {
    // getServData();
    menuGlobalNominations.addEventListener('click', initGlobalNominations)
    menuGlobalTechs.addEventListener('click', initGlobalTechs)
    menuGlobalPosts.addEventListener('click', initGlobalPosts)
    // menuGlobalSectionsForJury.addEventListener('click', initGlobalSectionsForJury);
  },

  redraw: getServData,

  stop() {
    pointsMarkup.cleanContainer();
    menuGlobalNominations.removeEventListener('click', initGlobalNominations)
    menuGlobalTechs.removeEventListener('click', initGlobalTechs)
    menuGlobalPosts.removeEventListener('click', initGlobalPosts)
    // menuGlobalSectionsForJury.removeEventListener('click', initGlobalSectionsForJury);

  }
};
